<template>
  <list-template
    :search-config="searchConfig"
    :table-config="tableConfig"
    :table-data="tableData"
    :total="total"
    :loading="loading"
    :current-page="page"
    @onHandle="handleClick"
    @onExportList="handDownload(0)"
    @onExportData="handDownload(1)"
    @onExportAll="handDownload(2)"
    @onSearch="onSearch"
    @onReset="onReset"
    @onChangePage="handleCurrentChange"
    @onChange="onChange"
  >
  </list-template>
</template>

<script>
import { tableListMixin } from '@/utils/mixins'
import { setConfigOption } from '@/utils'
import { fileDownload, getEnrollmentYear, getActualSchool, getAllGrade } from '@/api'
export default {
  _config:{'route':{'path':'list','meta':{'title':'列表','keepAlive':true}}},
  mixins: [tableListMixin],
  data() {
    return {
      searchConfig: [
        { placeholder: '搜索学生姓名', prop: 'student_name' },
        { placeholder: '搜索归属招生老师', prop: 'teacher_name' },
        { placeholder: '筛选缴费状态', tag: 'select', prop: 'pay_status', options: [{ label: '已缴清', value: 1 }, { label: '未缴清', value: 0 }] },
        { placeholder: '筛选审批状态', tag: 'select', prop: 'approve_status', options: [{ label: '待审批', value: 0 }, { label: '-', value: 1 }] },
        { placeholder: '筛选订单类型', tag: 'select', prop: 'order_type', options: [{ value: 2, label: '应届生正式报名' }, { value: 7, label: '转学生正式报名' }, { value: 4, label: '复读生正式报名' }, { value: 3, label: '在校生续费' }, { value: 100, label: '其他费用缴纳' }] },
        { placeholder: '筛选缴费学年', tag: 'year', prop: 'school_year' },
        { placeholder: '筛选入账学校', tag: 'select', prop: 'school_id', options: [] },
        { placeholder: '筛选报名年级', tag: 'select', prop: 'grade_id', options: [] },
        { placeholder: '筛选分期方式', tag: 'select', prop: 'is_by_stages', options: [{ label: '明细分期', value: 1 }, { label: '部分欠缴', value: 2 }] },
        {
          tag: 'datePicker',
          prop: 'pay_time',
          property: {
            'value-format': 'yyyy-MM-dd',
            type: 'daterange',
            'range-separator': '至',
            'start-placeholder': '缴费开始日期',
            'end-placeholder': '缴费结束日期'
          }
        }
      ],
      tableConfig: [
        { prop: 'pay_status_txt', label: '缴费状态', render({pay_status, pay_status_txt}) {
          const color = ['#F53F3F', '#23C343']
          return `<span style="color:${color[pay_status]}"}>${pay_status_txt}</span>`
        } },
        { prop: 'approve_status_txt', label: '审批状态', render({approve_status, approve_status_txt}) {
          return `<span style="${approve_status ? '' : 'color:#F6AD3C'}"}>${approve_status_txt}</span>`
        } },
        { prop: 'order_type', label: '订单类型' },
        { prop: 'year', label: '缴费学年' },
        { prop: 'student_name', label: '学生姓名' },
        { prop: 'school_name', label: '入账学校' },
        { prop: 'grade_name', label: '报名年级' },
        { prop: 'is_by_stages', label: '分期方式' },
        { prop: 'money_answer_actual_total', label: '实际应缴总额' },
        { prop: 'money_actual_total', label: '实际支付总额' },
        { prop: 'to_pay_money', label: '欠缴总额' },
        { prop: 'teacher_name', label: '归属招生老师' },
        { label: '操作', width: '100rem', handle: true }
      ]
    }
  },
  created() {
    this.getConfig()
  },
  methods: {
    getConfig() {
      getEnrollmentYear().then(res => {
        setConfigOption({ list: this.searchConfig, data: res, key: 'year' })
      })
      getActualSchool().then(res => {
        setConfigOption({ list: this.searchConfig , data: res, key: 'school_id' })
      })
      getAllGrade().then(res => {
        setConfigOption({ list: this.searchConfig , data: res, key: 'grade_id' })
      })
    },
    getData() {
      this.getDataApi('/zhaosheng/api/finance/installment-pay/order-list')
    },
    onBeforeSearch(val) {
      let { pay_time, ...rest } = val
      const data = { ...rest }
      if (pay_time) {
        const [start, end] = pay_time
        data.pay_time = `${start}~${end}`
      }
      this.search = { ...data }
    },
    handDownload(v) {
      const arr = ['列表', '数据', '缴费明细']
      const name = `分期支付审批${arr[v]}`
      fileDownload(`/zhaosheng/api/finance/installment-pay/order-export-v${v+1}`, { ...this.search }, { name, show: true })
    },
    handleClick(row) {
      const path = `./edit${(row.is_old_data === 1 || (row.year < 2026 && row.order_type_org === 2)) ? '-old' : ''}?id=${row.id}`
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped></style>
